<template>
  <div>
    <div class="video">
      <div class="container">
        <ul class="columns">
          <li class="column is-half-tablet is-one-third-desktop">
            <p>{{data.title}}</p>
            <div class="video">
              <video :src="data.src" :poster="data.poster" controls="controls"></video>
            </div>
            <p>视频文件较大，建议在WiFi环境下观看。</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
// import myBus from './vueBus.js'
import videos from '../util/video.js'

// src:item.videoUrl,title:item.title,poster:item.imgUrl
export default {
  data () {
    return {
      data: {},
      id: this.$route.params.id
      // src: videos[0].videoUrl,
      // poster: videos[0].imgUrl,
      // title: videos[0].title,
      // id: $route.params.id,
      // index: 0,
      // ...videos
    }
  },
  // 勾子函数执行前,组件实例还没被创建
  // beforeRouteEnter(to,from,next){
  //     let scrollTop0 = false;
  //     next(vm =>{
  //         vm.scrollTop0 = scrollTop0;
  //     })
  // },

  created () {
    this.setScrollTop(0)
    // let videos = videos
    // console.log(videos)
    // this.findIndex()
    // this.data = videos[index]
    // myBus.$emit('changeScrollRule')
    this.findItem(videos.videos)
  },
  methods: {
    setScrollTop (value) {
      if (document.documentElement && document.documentElement.scrollTop) {
        document.documentElement.scrollTop = value
      } else if (document.body) {
        document.body.scrollTop = value
      }
    },
    findItem (array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].id === this.id) {
          this.data.src = array[i].videoUrl
          this.data.title = array[i].title
          this.data.poster = array[i].imgUrl
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "../style/variable"

.video
  padding: 4.5rem 0 3rem
  .container
    width: 96vm
    padding-left: 1rem
    padding-right: 1rem
    .columns
      margin-top: 20px
      flex-wrap: wrap
      margin-left: initial
      margin-right: initial
      li.column
        background-color: #fff
        padding: 0
        p:first-child
          font-size: 16px
          text-align: left
          margin-bottom: 18px
        p:last-child
          margin-top: 12px
          font-size: 14px
          color: #ccc
          text-align: center
        .video
          padding: initial

</style>



// WEBPACK FOOTER //
// VideoList.vue?c78482aa